<template lang="pug">
  el-row#placeholder-container-student(
    @mouseover.native="isHover=true"
    @mouseleave.native="isHover=false")
  
    // Question Header
    h3#question-header {{ questionInfo.title }} 

    // Question Text
    div#placeholder-content(v-html="questionInfo.text")

    // Question Solution
    div#placeholder-content(v-if="questionInfo.solution!= undefined" )
      p.margin-top-30(style="font-weight: 700; font-style: italic;") Input as solution: &nbsp
      span(style="font-size: 1.25em;" v-html="questionInfo.solution")
    
    // Question Custom Content
    component(
      :is="viewType"
      :mainInfo="questionInfo"
      @questionSubmitted="(obj) => $emit('questionSubmitted', obj)"
    )
</template>

<script>
import AnswerInputView from "@/components/demo/questions/AnswerInputView";
import CodingView from "@/components/demo/questions/CodingView";

export default {
  name: "QuestionPlaceholder",

  components: {
    AnswerInputView,
    CodingView
  },

  props: {
    questionInfo: {
      type: Object,
      required: true
    },

    index: {
      type: Number,
      default: 0
    },

    totalCount: {
      type: Number,
      default: 0
    }
  },

  computed: {
    viewType() {
      const viewTypes = ["None", "AnswerInputView", "CodingView"];
      return viewTypes[this.questionInfo.type_id];
    }
  }
};
</script>

<style module>
#placeholder-container-student {
  min-height: 300px;
  margin-bottom: 10px;
  border: 1px solid #f1f1f1;
  border-radius: 7px;
}

#question-header {
  min-height: 40px;
  font-size: 2em;
  font-weight: bold;
  margin-top: 20px;
}
</style>
